import OptionsMenu from '@/components/OptionsMenu/options-menu.example';

export default OptionsMenu;
